var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26916_47005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33203 5.33301V3.99967C5.33203 2.52692 6.52594 1.33301 7.9987 1.33301L11.9987 1.33301C13.4715 1.33301 14.6654 2.52692 14.6654 3.99967V7.99967C14.6654 9.47243 13.4715 10.6663 11.9987 10.6663H10.6654M5.33203 5.33301H3.9987C2.52594 5.33301 1.33203 6.52692 1.33203 7.99967V11.9997C1.33203 13.4724 2.52594 14.6663 3.9987 14.6663H7.9987C9.47146 14.6663 10.6654 13.4724 10.6654 11.9997V10.6663M5.33203 5.33301H7.9987C9.47146 5.33301 10.6654 6.52692 10.6654 7.99967V10.6663",
    stroke: "#00535C",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26916_47005"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.98bebc9e.svg";
export { ForwardRef as ReactComponent };